import React from 'react';
import { IMyBusinessProps } from '../My_Business/myBusiness-hooks';
import Main from './Restaurant/Screens/Admin/Main/main';

const CofeShopPage: React.FC<IMyBusinessProps> = (props) => {

  return (
    <>
      <Main {...props}/>
    </>
  )
};

export default CofeShopPage